import { render, staticRenderFns } from "./chinatele.vue?vue&type=template&id=79f4a156&scoped=true&"
import script from "./chinatele.vue?vue&type=script&lang=js&"
export * from "./chinatele.vue?vue&type=script&lang=js&"
import style0 from "./chinatele.vue?vue&type=style&index=0&id=79f4a156&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f4a156",
  null
  
)

export default component.exports